<template>
  <div v-if="item">
    <h4>
      {{ "query" | setText("Запрос") }} # {{ item.id }} /
      {{ item.service.name }}
    </h4>
    <h5 class="text-success">
      {{ "status" | setText("Статус") }}:
      <span v-if="item.state === 'new'">Новый</span>
      <span v-else-if="item.is_compensation && item.state === 'sent'">{{
        "compensation_status" | setText("Компенсирован")
      }}</span>
      <span v-else-if="item.state === 'sent'">Оформлен</span>
      <span v-else>{{ "cancel_status" | setText("Отменен") }}</span>
    </h5>

    <div class="border">
      <div>
        <h5>
          Клиент: {{ item.client.first_name }} {{ item.client.last_name }}
        </h5>
        <h5>{{ "pinfl" | setText("ПИНФЛ") }}: {{ item.client.PINFL }}</h5>
        <h5>
          {{ "phone" | setText("Номер телефона") }} {{ item.client.phone }}
        </h5>
        <h5>{{ "product" | setText("Товар") }}: {{ item.name }}</h5>
        <h5>{{ "barcode" | setText("Баркод") }}: {{ item.barcode }}</h5>
        <h5>IMEI: {{ item.code }}</h5>
      </div>
      <div>
        <h5>Запрос на компенацию: {{ item.is_compensation ? "Да" : "Нет" }}</h5>
        <h5 v-if="item.is_compensation">
          Сумма компенации:
          {{ item.price_compensation | spaceBetweenNumber }} UZS
        </h5>
        <h5 v-if="item.is_compensation">
          <a class="btn btn-info mw mb-3" target="_blank" :href="item.link"
            >Скачать сертификат</a
          >
        </h5>
      </div>

      <h5>
        <span class="text-info"> Стоимость товара:</span>
        {{ item.price_variant | spaceBetweenNumber }} UZS
      </h5>

      <h5>
        <span class="text-info">Цена сертификата KeepTalk:</span>
        {{ item.price_partner | spaceBetweenNumber }} UZS
      </h5>

      <h5>
        <span class="text-info"> Услуга оформления: </span>
        {{ item.price | spaceBetweenNumber }} UZS
      </h5>

      <h5>
        <span class="text-info">Итоговая цена: </span>
        {{ (item.price + item.price_partner) | spaceBetweenNumber }} UZS
      </h5>
    </div>

    <component
      v-if="item"
      :is="item.service.code"
      :data="item"
      v-model="value"
      @input="updateItem"
      :update="updateItem"
    />
  </div>
</template>

<script>
import { cardContent, toFormData, errorNotify } from "@/plugins/functions";

export default {
  components: {
    keeptok: () => import("@/components/Services/keeptok"),
  },
  data: () => ({
    cardLink: "certificates",
    item: null,
    value: {},
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardContent: cardContent,
    async updateItem() {
      this.$loading(true);
      return this.$http({
        method: "post",
        data: toFormData({ _method: "put", ...this.value }),
        url: `certificates/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.item = response.data.data;
          return response.data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>
<style>
</style>
